export enum GenreCategoryName {
  Entertainment = "エンタメ・趣味",
  Music = "音楽",
  Nature = "自然",
  Lifestyle = "政治・社会・ライフスタイル",
  Animal = "動物",
  Fashion = "ファッション",
  Sport = "スポーツ",
  Outdoor = "住まい・アウトドア",
  Vehicle = "乗り物",
  Health = "美容・健康",
  Occupation = "職業",
  Family = "ファミリー・キッズ",
  Gourmet = "グルメ・料理・食品・飲料",
  Business = "ビジネス・教養・IT",
  Travel = "旅行・お出かけ・施設",
  Education = "教育・学問",
  Medical = "医療",
  Service = "サービス・商品・家電",
}
